import React, { useContext, useMemo, useState } from "react";
import Tabs from "../../CommonComponents/Tabs";
import SharedPaths from "./SharedPaths";
import ToggleButton from "../../CommonComponents/ToggleButton";
import Search from "../../CommonComponents/Search";
import Button from "../../Button";
import Modal from "../../CommonComponents/Modal";
import CreatePath from "./CreatePath";
import PathList from "./PathList";
import { useDebouncedValue } from "../../../Hooks/useDebounceValue";
import InputDropdown from "../../CommonComponents/InputDropdown";
import constants from "../../../constants";
import AlertContext from "../../../context/AlertContext";
import { isGradiousAdmin, isGradiousCompany } from "../../../util";
import TabList from "../../CommonComponents/TabList";
import Tab from "../../CommonComponents/Tab";
import TabPanels from "../../CommonComponents/TabPanels";
import TabPanel from "../../CommonComponents/TabPanel";

const sharedScopeOptions = [
  { label: "All", value: "all" },
  { label: "Public", value: constants.SHARED_SCOPE.PUBLIC },
  { label: "Private", value: constants.SHARED_SCOPE.PRIVATE },
  { label: "Specific", value: constants.SHARED_SCOPE.SPECIFIC },
];

const AdminLearningPath = () => {
  const { selectedScope, setSelectedScope } = useContext(AlertContext);
  const [openModal, setOpenModal] = useState(false);
  const [activeTab, setActiveTab] = useState("paths");
  const [pathDetail, setPathDetail] = useState({
    name: "",
    description: "",
    thumbnail: null,
  });
  const [search, setSearch] = useState("");
  const [archieve, setArchieve] = useState(false);

  const debounceValue = useDebouncedValue(search, 500);

  const GradiousCompany = useMemo(() => isGradiousCompany(), []);
  const GradiousAdmin = useMemo(() => isGradiousAdmin(), []);

  // Tab configuration
  const tabs = useMemo(
    () => [
      {
        key: "shared-paths",
        label: `${GradiousCompany ? "Shared Paths" : "Gradious"}`,
        content: <SharedPaths searchValue={debounceValue} />,
      },
      {
        key: "paths",
        label: "Paths",
        content: <PathList searchValue={debounceValue} archieve={archieve} />,
      },
    ],
    [debounceValue, archieve],
  );

  const onCreatePath = () => {
    setOpenModal(true);
  };

  return (
    <div className="admin-path-container">
      <Tabs
        value={activeTab}
        onChange={setActiveTab}
        tabItems={tabs}
        className="admin-path-tabs"
      >
        <TabList>
          {tabs?.map((item) => (
            <Tab key={item.key} value={item.key}>
              {item.label}
            </Tab>
          ))}
        </TabList>
        <TabPanels>
          {tabs?.map((item) => (
            <TabPanel key={item.key} value={item.key}>
              {item.content}
            </TabPanel>
          ))}
        </TabPanels>
      </Tabs>
      {activeTab === "paths" ? (
        <React.Fragment>
          <div className="admin-path-util-container">
            <ToggleButton
              size="sm"
              text="Archive"
              pressed={archieve}
              onChange={(value) => setArchieve(value)}
            />
            <Search
              placeholder="Search"
              iconPosition="end"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <Button
              size="sm"
              hierarchy={{ type: "primary", buttonText: "Create Path" }}
              icon={{
                icon: (
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.66829 0.834961V12.5016M0.834961 6.66829H12.5016"
                      stroke="white"
                      strokeWidth="1.67"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                ),
                type: "leading",
              }}
              onClick={onCreatePath}
            />
          </div>

          <Modal
            title="Learningpath"
            isOpen={openModal}
            onClose={() => setOpenModal(false)}
            className="admin-path-create-modal"
          >
            <CreatePath
              setOpenModal={setOpenModal}
              pathDetail={pathDetail}
              setPathDetail={setPathDetail}
            />
          </Modal>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <div className="admin-path-util-container">
            <Search
              placeholder="Search"
              iconPosition="end"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />

            {GradiousAdmin && (
              <InputDropdown
                type="default"
                placeholder="Shared Scope"
                options={sharedScopeOptions}
                searchable
                onChange={setSelectedScope}
                value={selectedScope}
              />
            )}
          </div>
        </React.Fragment>
      )}
    </div>
  );
};

export default AdminLearningPath;
